import { makeStyles } from '@material-ui/core/styles';

import { IconTileStyleProps } from './IconTile.types';

export const useStyles = makeStyles(theme => ({
  container: {
    padding: theme.spacing(5.125, 0, 4.875, 0),
    backgroundColor: (props: IconTileStyleProps) => props.backgroundColor || theme.palette.gray.dark,
    borderRadius: theme.spacing(2),
    color: (props: IconTileStyleProps) => props.color,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    height: '100%',

    '@media screen and (max-height: 800px)': {
      padding: theme.spacing(4, 0, 2.4375, 0),
    },
  },
  icon: {
    display: 'flex',
    justifyContent: 'center',
    width: theme.spacing(6),
    height: theme.spacing(6),
    marginBottom: theme.spacing(4),

    '@media screen and (max-height: 600px)': {
      marginBottom: theme.spacing(2),
    },
  },
  iconFullSize: {
    '& svg': {
      width: '100%',
      height: '100%',
    },
  },
  title: {
    ...theme.typography.h3,
    fontFamily: theme.typography.secondaryFontFamily,
    fontWeight: theme.typography.fontWeightBold,
    color: theme.palette.text.primary,
    textAlign: 'center',
  },
  dotsIcon: {
    marginTop: 'auto',
  },
}));
